import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Card, Table, Spin, Alert, Button, Avatar, Typography, Row, Col } from 'antd';
import { UserOutlined, TrophyOutlined, CalendarOutlined } from '@ant-design/icons';
import { useAuth } from "../AuthContext";
import Cookies from "js-cookie";
import "./styles.css";
import {SERVER_BASE_URL} from "../../Constants";
import {Form} from "react-bootstrap";

const { Title, Text } = Typography;

const Profile = () => {
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const { isLoggedIn, logout } = useAuth();
    const [registeredCompetitions, setRegisteredCompetitions] = useState([]);
    const [selectedCompetition, setSelectedCompetition] = useState(null);

    useEffect(() => {
        document.title = "Profile";
    }, []);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                if (!isLoggedIn()) {
                    navigate('/login');
                    return;
                }

                const token = Cookies.get("token");

                const response = await axios.get(SERVER_BASE_URL + 'api/users/profile', {
                    headers: { Authorization: `Bearer ${token}` }
                });

                setUserData(response.data);

                if (response.data.registered_competitions.length > 0) {
                    console.log(response.data.registered_competitions)
                    setRegisteredCompetitions(response.data.registered_competitions);
                    setSelectedCompetition(response.data.registered_competitions[0]);
                }

                setLoading(false);
            } catch (err) {
                console.log(err);
                if (err.status === 401) {
                    logout();
                    navigate('/login');
                }
                setError('Failed to load data');
            }
        };

        fetchUserData();
    }, [navigate]);

    const handleRegister = () => {
        navigate('/register-competition');
    };

    const handleSubmitResult = () => {
        navigate('/submit-result', { state: { competitionId: selectedCompetition.competition.competition_id } });
    };

    if (loading) return <Spin size="large" className="spinner-center" />;
    if (error) return <Alert message={error} type="error" className="alert-center" />;


    return (
        <div className="container">
            <Row gutter={[16, 16]} className="profile-row">
                {/* User Profile Card */}
                <Col xs={24} md={12} className="profile-col" >
                    <Card className="profile-card" title="User Profile">
                        <Row align="middle">
                            <Col xxs={24} md={6} className="text-center" style={{ display: "flex", justifyContent: "center" }}>
                                <Avatar size={100} icon={<UserOutlined />} src={userData?.user?.profile_picture} />
                            </Col>
                            <Col xs={2} md={2}></Col>
                            <Col xs={22} md={16} >
                                <Title level={5}>{userData.user.fist_name} {userData.user.last_name}</Title>
                                <Text>Email: {userData.user.email}</Text><br />
                                <Text>Competition Gender: {userData.user.competition_gender}</Text>
                                <Form.Group controlId="competitionSelect" className="mb-3">
                                    <Form.Label>Select Competition:</Form.Label>
                                    <Form.Select
                                        value={selectedCompetition?.competition.competition_id || ''}
                                        onChange={(e) => {
                                            const comp = registeredCompetitions.find(c => c.competition.competition_id === Number(e.target.value));
                                            setSelectedCompetition(comp || null);
                                        }}
                                        required
                                    >
                                        {/*<option value="">Choose...</option>*/}
                                        {registeredCompetitions.map(comp => (
                                            <option key={comp.competition.competition_id} value={comp.competition.competition_id}>
                                                {comp.competition.competition_name}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Card>
                </Col>

                {selectedCompetition && (
                <Col xs={24} md={12} className="profile-col">
                    <Card className="competition-card" title="Enrolled Competition">
                        <Title level={5}>
                            <TrophyOutlined /> {selectedCompetition?.competition.competition_name}
                        </Title>
                        <Text>{selectedCompetition?.competition.description}</Text><br />
                        <Text>
                            <CalendarOutlined /> <strong>Start Date:</strong> {new Date(selectedCompetition?.competition.start_date).toLocaleDateString()} |
                            <strong> End Date:</strong> {new Date(selectedCompetition?.competition.end_date).toLocaleDateString()}
                        </Text><br />
                        <Text><strong>Overall Rank:</strong> {selectedCompetition?.overall_rank}</Text><br/>
                        <Text>{selectedCompetition?.competition.participation_type !== 'Individual' && (
                            <>
                                {selectedCompetition?.team ? (
                                    <>
                                        <Text><strong>Team:</strong> {selectedCompetition.team.team_name}</Text><br />
                                        <Button block type="primary" className="mt-2" onClick={handleSubmitResult}>
                                            Submit Result
                                        </Button>
                                    </>
                                ) : (
                                    <>
                                        <Text type="warning"><strong>You are not in a team yet.</strong></Text><br />
                                        <Button block type="primary" className="mt-2" onClick={() => navigate("/teams/join?competitionId=" + selectedCompetition.competition.competition_id)}>
                                            Join or Create Team
                                        </Button>
                                    </>
                                )}
                            </>
                        )}</Text>


                        {selectedCompetition?.competition.participation_type === 'Individual' && (
                            <Button block type="primary" className="mt-2" onClick={handleSubmitResult}>
                                Submit Result
                            </Button>
                        )}

                    </Card>
                </Col>)}
            </Row>


            {/* Workout Results Table */}
            {selectedCompetition && (
                <Table
                    className="workout-table"
                    bordered
                    pagination={false}
                    dataSource={selectedCompetition.workouts.map(workout => {
                        const result = selectedCompetition.user_results.find(res => res.workout_id === workout.workout_id);
                        console.log(result);
                        return {
                            key: workout.workout_id,
                            workout: workout.workout_name,
                            scoreDisplay: result && !!result.display_score ? result.display_score : "----",
                        };
                    })}
                    columns={[
                        { title: "Workout", dataIndex: "workout", key: "workout" },
                        { title: "Score Display", dataIndex: "scoreDisplay", key: "workout" },
                    ]}
                />


            )}

            {/* Register Button */}
            <Button type="default" block onClick={handleRegister} className="register-button">
                Register for Competition
            </Button>
        </div>
    );
};

export default Profile;